import { FC, useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import arrowImage from 'assets/images/arrow.svg';
import LeftQuoteImage from 'assets/images/fill-left.svg';
import RightQuoteImage from 'assets/images/fill-right.svg';

import S from './TestimonialsSection.Styled';

export interface TestimonialProp {
  text: string;
  name: string;
}

const TestimonialCard: FC<TestimonialProp> = ({ text, name }) => (
  <S.TestimonialCard>
    <S.TestimonialContainer>
      <S.Quote src={LeftQuoteImage} />
      <S.Testimonial>{text}</S.Testimonial>
      <S.Quote src={RightQuoteImage} />
    </S.TestimonialContainer>
    <S.Name>{name}</S.Name>
  </S.TestimonialCard>
);

const settings: Settings = {
  infinite: true,
  autoplay: false,
  dots: false,
  draggable: true,
  arrows: false,
  easing: 'ease-in-out',
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

interface TestimonialsSectionProps {
  backgroundColor?: string;
  title: string;
  testimonials: TestimonialProp[];
}

export const TestimonialsSection: FC<TestimonialsSectionProps> = ({ backgroundColor, title, testimonials }) => {
  const sliderRef = useRef<Slider>(null);

  return (
    <S.Section backgroundColor={backgroundColor}>
      <S.Title>{title}</S.Title>
      <S.CarouselWrapper>
        <S.ButtonsWrapper>
          <S.CircleButtonLeft onClick={() => sliderRef?.current?.slickPrev()}>
            <img src={arrowImage} alt="left arrow button" />
          </S.CircleButtonLeft>
          <S.CircleButtonRight onClick={() => sliderRef?.current?.slickNext()}>
            <img src={arrowImage} alt="right arrow button" />
          </S.CircleButtonRight>
        </S.ButtonsWrapper>
        <Slider ref={sliderRef} {...settings}>
          {testimonials.map((testimonial) => (
            <S.TestimonialCardWrapper key={testimonial.name}>
              <TestimonialCard text={testimonial.text} name={testimonial.name} />
            </S.TestimonialCardWrapper>
          ))}
        </Slider>
      </S.CarouselWrapper>
    </S.Section>
  );
};
